import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: var(--lisa-background);

  .content {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .videoContainer {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 0 10%;
    margin-top: 5%;
  }
  .video {
    display: flex;
    justify-content: center;

    background-color: #000;
  }

  video {
    width: 84%;
  }

  .buttonContainer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 0.5rem;

    button {
      width: auto;
      height: auto;
      font-size: 1em;
      padding: 0.5em 1.2em;
      min-width: 64px;
      min-height: 36px;
      box-sizing: border-box;
    }
  }

  .menuBtn {
    background: none;
    border: 0;
  }
`;
